'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './project-list.routes';

export class ProjectListComponent {
  constructor(Auth, ProjectService, dialogs, DTOptionsBuilder, DTState) {
    'ngInject';

    this.ProjectService = ProjectService;
    this.data = [];

    this.dialogs = dialogs;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'desc'])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Projects"
      },{
        extend: 'csv',
        title: "Projects"
      },{
        title: "Projects",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "Projects"
      }]);

    this.ProjectService.query((data) => {
      this.data = data;
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve project.")
    });
  }

  delete(project) {
    var that = this;

    var projectText = "<br/><br/><b>" + project.name + "</b><br/><p>" + project.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Project?", "<i class='fa fa-5x fa-fw text-danger fa-warning' style='float:right'></i>Do you really want to delete this project?" + projectText);
    dlg.result.then(() => {
      // OK delete it
      that.ProjectService.delete({id: project._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== project._id;
          });
        },
        err => {
          alert("Could not delete project");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.projectList', [uiRouter])
  .config(routes)
  .component('projectList', {
    template: require('./project-list.html'),
    controller: ProjectListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/project/list/project-list.component.js